import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class WorkComCriteria extends BasicCriteria {
visionCode: string;
}

